import { css } from 'emotion';

import { colors } from '@cobliteam/base-components/src/styles/colors';
import { fonts } from '@cobliteam/base-components/src/styles/fonts';
import { getRGBA } from '@cobliteam/base-components/src/styles/helpers';
import { icons } from '@cobliteam/base-components/src/styles/icons';

export const stepContainer = css`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  border-radius: 5px;
  border: 1px solid ${colors.gray.light};
  padding: 20px;
  height: 59px;

  &:hover {
    background-color: ${colors.custom.lightGray50Alternative};
  }
`;

export const accordionSummary = css`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  width: 100%;

  > div {
    display: flex;
    gap: 10px;
    align-items: center;
  }
`;

export const accordionSummaryTitle = (completed: boolean, blocked?: boolean) => css`
  color: ${blocked ? colors.gray.default : colors.gray.dark};
  text-decoration: ${completed ? 'line-through' : 'none'};
`;

export const accordionSummaryActions = css`
  display: flex;
  justify-content: space-between;
  gap: 20px;
`;

export const accordionSummaryIcon = (blocked?: boolean) => css`
  width: 16px;
  height: 16px;
  color: ${blocked ? colors.gray.default : colors.gray.dark};
`;

export const accordionContainer = css`
  border-radius: 5px;
  border: 1px solid ${colors.gray.light};
  overflow: hidden;
`;

export const accordionSummaryWrapper = css`
  min-height: 0;
  &.Mui-expanded:first-of-type {
    min-height: 0;
    border-bottom: 1px solid ${colors.gray.light};
  }
`;

export const accordionWrapper = css`
  border: none;
  padding: 0;
  display: flex;
  flex-direction: column;
`;

export const accordionContent = css`
  display: flex;
  justify-content: space-between;
  padding: 28px;
  width: 100%;
  align-items: center;
  gap: 10px;
`;

export const colotGrayDark = css`
  color: ${colors.gray.dark};
`;

export const divider = css`
  padding: 0 20px;
`;

export const itemBadgeObd = css`
  > div {
    > span {
      color: ${colors.gray.dark};
      font-weight: ${fonts.weight.regular};
    }

    > svg {
      width: ${icons.size.smallest};
      height: ${icons.size.smallest};
      color: ${colors.gray.dark};
    }

    background-color: ${getRGBA(colors.gray.dark, 0.1)};
  }
`;

export const videoModal = css`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const videoModalPaper = css`
  border-radius: 12px;
  overflow: auto;
  max-height: 60dvh;
  margin: 20px;
`;

export const videoModalContent = css`
  margin-top: 20px;
  display: flex;
  flex-direction: column;
  gap: 20px;

  text-area < div {
    background-color: ${colors.gray.lightest};
  }
`;

export const videoModalActionPositiveButton = css`
  color: ${colors.gray.dark};
  &:hover {
    color: ${colors.success.hover};
    background-color: ${colors.gray.lightest};
  }
`;

export const videoModalActionPositiveButtonActive = css`
  color: ${colors.success.hover};
`;

export const videoModalActionNegativeButton = css`
  color: ${colors.gray.dark};
  &:hover {
    color: ${colors.error.hover};
    background-color: ${colors.gray.lightest};
  }
`;

export const videoModalActionNegativeButtonActive = css`
  color: ${colors.error.hover};
`;

export const videoModalContentTextarea = css`
  background-color: ${colors.gray.lightest};
  border: 0;
  border-radius: 12px;
`;

export const videoModalActions = css`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
`;

export const stepNumberIcon = css`
  color: ${colors.primary.default};
  background-color: ${colors.custom.accessory};
`;

export const stepNumberIconNotCompleted = css`
  color: ${colors.white};
  background-color: ${colors.primary.default};
`;

export const stepNumberIconBadge = css`
  color: ${colors.custom.accessory};
  background-color: ${colors.primary.default};
  width: 16px;
  height: 16px;

  > svg {
    color: ${colors.white};
    width: 12px;
    height: 12px;
  }
`;

export const stepNumberIconBlocked = css`
  color: ${colors.white};
  background-color: ${colors.custom.gray50};
`;

export const checkIcon = css`
  color: ${colors.success.default};
  flex-shrink: 0;
  margin-left: 10px;
`;

export const checkIconDisabled = css`
  color: ${colors.gray.default};
  flex-shrink: 0;
  margin-left: 10px;
`;
